'use client';

import { useEffect, useRef } from 'react';
import { trackLpCtaClick } from '@/lib/analytics';

/**
 * Верх рекламной воронки: клики по CTA лендинга /for-business
 * (ТЗ LP-GOALS, задача A).
 *
 * Один делегированный слушатель на document вместо onClick на каждой кнопке —
 * вёрстку лендинга трогать нельзя, а CTA там три штуки в разных секциях.
 * Монтируется ТОЛЬКО на /for-business: в providers.tsx нельзя, иначе цель
 * начнёт ловить клики по всему сайту.
 */

const CTA_SELECTOR = '.lp-btn-primary, .lp-nav-cta, .lp-btn-large';
const LABEL_MAX_LEN = 50;
/** Защита от двойного клика: одна отправка на элемент за 2 секунды. */
const DEDUP_MS = 2000;

export default function LandingCtaTracker() {
  // WeakMap, а не одна метка времени: дедуплицируем каждый CTA независимо,
  // клик по второй кнопке сразу после первой должен считаться.
  const lastSentRef = useRef<WeakMap<Element, number>>(new WeakMap());

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      try {
        const target = e.target;
        if (!(target instanceof Element)) return;

        const cta = target.closest(CTA_SELECTOR);
        if (!cta) return;

        const now = Date.now();
        const last = lastSentRef.current.get(cta);
        if (last !== undefined && now - last < DEDUP_MS) return;
        lastSentRef.current.set(cta, now);

        const label = (cta.textContent ?? '').trim().slice(0, LABEL_MAX_LEN);
        trackLpCtaClick(label);
      } catch {
        // Аналитика вспомогательна — не мешаем переходу по ссылке.
      }
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return null;
}
